import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { EventsQuery } from '../../../../apollo/__generated__/graphql';
import { EventForm } from '../EventForm/EventForm';
import { useEditEventDrawer } from './useEditEventDrawer';

interface EditEventDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  event: EventsQuery['events'][number];
}

export const EditEventDrawer: FunctionComponent<EditEventDrawerProps> = ({
  isOpen,
  onClose,
  event,
}) => {
  const {
    endAtValue,
    errors,
    onEndAtChange,
    onStartAtChange,
    onSubmit,
    register,
    onPlaceChange,
    startAtValue,
    onTypeChange,
    type,
  } = useEditEventDrawer(event, onClose);

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Modifier un événement</Typography>
        <EventForm
          register={register}
          onSubmit={onSubmit}
          errors={errors}
          endAtValue={endAtValue}
          startAtValue={startAtValue}
          onEndAtChange={onEndAtChange}
          onStartAtChange={onStartAtChange}
          onPlaceChange={onPlaceChange}
          submitButtonLabel="Modifier"
          onTypeChange={onTypeChange}
          type={type}
        />
      </Box>
    </Drawer>
  );
};
